export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoid2lsbC12ZW51ZXNjb3V0IiwiYSI6ImNsNzh5ZG44ejA4NjYzd280ZDViczZjOXgifQ.bfG0adlNR88Z_9mcgG4TWg';
export const MAPBOX_STYLE =
  'mapbox://styles/chrispauli82/cktsp6xt45ct317p6k4bx1chs';
